_getUserAccountDataBillingSubscriptionsWithDetailsThunk